/*
 * <before-after-grid>: shows the first rows × columns pairs until "View more" is pressed.
 * Columns come from the CSS (--before-after-columns per breakpoint), rows from data-rows.
 */
if (!customElements.get('before-after-grid')) {
  customElements.define(
    'before-after-grid',
    class BeforeAfterGrid extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.before-after__item')];
        this.more = this.querySelector('.before-after__more');
        this.button = this.more?.querySelector('button');
        if (!this.button) return;

        this.button.addEventListener('click', () => this.expand());
        this.layout = this.layout.bind(this);
        this.resizeObserver = new ResizeObserver(this.layout);
        this.resizeObserver.observe(this);
        this.layout();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      expand() {
        this.removeAttribute('data-collapsed');
        this.button.setAttribute('aria-expanded', 'true');
        this.layout();
      }

      layout() {
        const columns = parseInt(getComputedStyle(this).getPropertyValue('--before-after-columns'), 10) || 1;
        const limit = columns * (parseInt(this.dataset.rows, 10) || 2);
        this.items.forEach((item, index) => item.classList.toggle('is-overflow', index >= limit));
        this.more.hidden = !this.hasAttribute('data-collapsed') || this.items.length <= limit;
      }
    }
  );
}
